var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Welcher Jobtitel soll BewerberInnen angezeigt werden?"
          }
        },
        [
          _c("b-input", {
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveName.apply(null, arguments)
              }
            },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Button", {
        attrs: {
          text: "Speichern",
          icon: "checkmark",
          disabled: !_vm.nameValid || _vm.saving,
          loading: _vm.saving
        },
        on: { click: _vm.saveName }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("LockInfo", { staticClass: "mt-4" }, [
        _vm._v("\n\t\tDer Jobtitel ist im Nachhinein nicht mehr änderbar.\n\t")
      ]),
      _vm._v(" "),
      _vm.confirm
        ? _c(
            "PopUp",
            {
              attrs: {
                title: "Job-Titel",
                "ok-text": "Speichern",
                "cancel-text": "Titel ändern",
                "ok-disabled": _vm.saving,
                "ok-loading": _vm.saving
              },
              on: {
                ok: _vm.saveName,
                hidden: function($event) {
                  _vm.confirm = false
                }
              }
            },
            [
              _c("div", [_c("b", [_vm._v(_vm._s(_vm.name))])]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n\t\t\tDer Titel kann nachträglich nicht mehr geändert werden."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\tBitte prüfe jetzt nochmals die Rechtschreibung.\n\t\t"
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("b", [_vm._v("ACHTUNG:")]),
      _vm._v(
        " dieser Jobtitel wird den Kandidaten angezeigt und darf daher\n\t\tkeine Hinweise auf deine Identität und Organisation beinhalten.\n\t"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }